/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { useDispatch } from 'react-redux';

function LastestNews() {
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();

  const getCategories = () => {
    axios.get('/api/v1/categories/show-home').then(({ data }) => {
      if (data.success) {
        setCategories([...data.payload]);
        dispatch({
          type: 'SET_CATEGORIES_ARTICLE',
          payload: [...data.payload],
        });
      }
    });
  };

  const getArticlesHighlight = () => {
    axios
      .get('/api/v1/article-page-custom', {
        params: {
          page: 1,
          limit: 3,
        },
      })
      .then(({ data }) => {
        if (data.success) {
          setArticles([...data.payload.articles]);
        }
      });
  };

  const getArticlesCategory = (currenPage = 1, limit = 3, routerNameNav) => {
    axios
      .get(`/api/v1/articles/article-category/${routerNameNav}`, {
        params: {
          page: currenPage,
          limit: limit,
        },
      })
      .then(({ data }) => {
        if (data.success) {
          setArticles([...data.payload.articles]);
        }
      });
  };

  useEffect(() => {
    getArticlesHighlight();
    getCategories();
  }, []);
  return (
    <>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='row d-flex justify-content-between'>
              <div className='col-lg-3 col-md-3'>
                <div className='widget-header position-relative mb-30'>
                  <h5 className='widget-title mb-30 text-uppercase color1 font-weight-ultra'>
                    Tin tức mới cập nhật
                  </h5>
                  <div className='letter-background'>T</div>
                </div>
              </div>
              <div className='col-lg-9 col-md-9'>
                <nav className='tab-nav style-1'>
                  <div className='nav nav-tabs' role='tablist'>
                    <a
                      className='nav-item nav-link active'
                      id='nav-home-tab'
                      data-toggle='tab'
                      href='#nav-home'
                      role='tab'
                      aria-controls='nav-home'
                      aria-selected='true'
                      onClick={() => {
                        getArticlesHighlight();
                      }}
                    >
                      <i className='mr-5 ti-pulse'></i>Tin tức chung
                    </a>
                    {categories.map(({ category_name, id, slug }) => (
                      <a
                        className='nav-item nav-link'
                        data-toggle='tab'
                        role='tab'
                        key={id}
                        href='#'
                        onClick={() => {
                          getArticlesCategory(1, 3, slug);
                        }}
                      >
                        {category_name}
                      </a>
                    ))}
                  </div>
                </nav>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <div className='tab-content' id='nav-tabContent'>
                  <div className='row'>
                    {articles.map(
                      ({
                        slug,
                        thumbnail,
                        is_video_news,
                        title,
                        id,
                        created_at,
                      }) => (
                        <div className='slider-single col-md-4 mb-30' key={id}>
                          <div
                            className='img-hover-scale border-radius-5'
                            style={{ height: '230px' }}
                          >
                            <a
                              href={`/${
                                is_video_news === 1 ? 'tin-video' : 'tin-tuc'
                              }/${slug}`}
                            >
                              <LazyLoad height='230px'>
                                <img
                                  width='100%'
                                  height='230px'
                                  className='border-radius-5'
                                  src={thumbnail}
                                  alt='post-slider'
                                />
                              </LazyLoad>
                            </a>
                          </div>
                          <h6 className='post-title pr-5 pl-5 mb-10 mt-15 text-limit-2-row'>
                            <a
                              href={`/${
                                is_video_news === 1 ? 'tin-video' : 'tin-tuc'
                              }/${slug}`}
                            >
                              {title}
                            </a>
                          </h6>
                          <div className='entry-meta meta-1 font-small color-grey mt-10 pr-5 pl-5'>
                            <span className='post-on'>{created_at}</span>
                            {/* <span className='hit-count has-dot'>23k Views</span> */}
                            {/* <a className='float-right' href='#'>
                              <i className='ti-heart'></i>
                            </a> */}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LastestNews;
